import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=02c9bf8a&"
import script from "./AdminPage.vue?vue&type=script&lang=ts&"
export * from "./AdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports